import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'

import {isBrowser} from '~/utils/helper'
import {req} from '~/utils/request'

// 从 localStorage 读取已保存的用户信息
const getInitialUser = () => {
  if (!isBrowser()) return null
  try {
    const savedUser = localStorage.getItem('user')
    if (savedUser) {
      return JSON.parse(savedUser)
    }
  } catch (e) {
    // localStorage.removeItem('user')
  }
  return null
}

const getInitialUserGoogle = () => {
  if (!isBrowser()) return null
  try {
    const savedUser = localStorage.getItem('user_google')
    if (savedUser) {
      return JSON.parse(savedUser)
    }
  } catch (e) {
    // localStorage.removeItem('user_google')
  }
  return null
}
const initialState = {
  user: getInitialUser(),
  user_google: getInitialUserGoogle(),
  showLoginModal: false,
}

export const openlogin = createAsyncThunk<any, any>(
  'openlogin',
  async (arg) => {
    return req({
      url: '/api/account/openlogin',
      params: {...arg},
    })
  }
)

export const submitMemoryFile = createAsyncThunk<any, any>(
  'submitMemoryFile',
  async (arg) => {
    return req({
      url: '/api/gateway/transmigration/submit_memory_file',
      params: {...arg},
    })
  }
)

export const submitCharacterRegister = createAsyncThunk<any, any>(
  'submitCharacterRegister',
  async (arg) => {
    return req({
      url: '/api/gateway/transmigration/submit_character_register',
      params: {...arg},
    })
  }
)

export const submitCharacterProfile = createAsyncThunk<any, any>(
  'submitCharacterProfile',
  async (arg) => {
    return req({
      url: '/api/gateway/transmigration/submit_character_profile',
      params: {...arg},
    })
  }
)

export const getMyApplyList = createAsyncThunk<any, any>(
  'getMyApplyList',
  async (arg) => {
    return req({
      url: '/api/gateway/transmigration/get_my_apply_list',
      params: {...arg},
    })
  }
)

export const getRegisterCount = createAsyncThunk<any, any>(
  'getRegisterCount',
  async (arg) => {
    return req({
      url: '/api/gateway/transmigration/get_register_count',
      params: {...arg},
    })
  }
)

export const websiteFeedback = createAsyncThunk<any, any>(
  'websiteFeedback',
  async (arg) => {
    return req({
      url: '/api/feedback/website_feedback',
      params: {...arg},
    })
  }
)

export const accountSlice = createSlice({
  name: 'account',
  initialState,
  reducers: {
    setUser: (state, action) => {
      // eslint-disable-next-line no-param-reassign
      state.user = action.payload
      // 保存到 localStorage
      if (action.payload) {
        localStorage.setItem('user', JSON.stringify(action.payload))
      } else {
        localStorage.removeItem('user')
      }
    },
    clearUser: (state) => {
      // eslint-disable-next-line no-param-reassign
      state.user = null
      localStorage.removeItem('user')
    },
    setUserGoogle: (state, action) => {
      // eslint-disable-next-line no-param-reassign
      state.user_google = action.payload
      // 保存到 localStorage
      if (action.payload) {
        localStorage.setItem('user_google', JSON.stringify(action.payload))
      } else {
        localStorage.removeItem('user_google')
      }
    },
    clearUserGoogle: (state) => {
      // eslint-disable-next-line no-param-reassign
      state.user_google = null
      localStorage.removeItem('user_google')
    },
    openLoginModal: (state) => {
      // eslint-disable-next-line no-param-reassign
      state.showLoginModal = true
    },
    closeLoginModal: (state) => {
      // eslint-disable-next-line no-param-reassign
      state.showLoginModal = false
    },
  },
  extraReducers: () => {},
})

export const {
  setUser,
  clearUser,
  setUserGoogle,
  clearUserGoogle,
  openLoginModal,
  closeLoginModal,
} = accountSlice.actions

export default accountSlice.reducer
